(function () {
  window.initProductInfoSliders = window.initProductInfoSliders || {};

  function isIOSSafari() {
    var ua = window.navigator.userAgent;
    var iOS = /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    return iOS && /WebKit/.test(ua) && !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua);
  }

  function isMobileGallery() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function injectGalleryStyles() {
    if (document.getElementById('product-flavor-slider-styles')) return;

    var style = document.createElement('style');
    style.id = 'product-flavor-slider-styles';
    style.textContent =
      '.section-product-info:not(.hidden) .primary-images .slick-slide img {' +
      'display:block;width:100%;height:auto;' +
      '-webkit-transform:translateZ(0);transform:translateZ(0);' +
      '}' +
      '@media (max-width:767px){' +
      '.primary-images .slider-nav.slider-nav--static{' +
      'display:flex!important;flex-wrap:nowrap;width:100%;margin-bottom:6px;' +
      'touch-action:manipulation;-webkit-tap-highlight-color:transparent;' +
      '}' +
      '.primary-images .slider-nav.slider-nav--static>.product-thumb{' +
      'flex:1 1 0;min-width:0;cursor:pointer;opacity:.5;' +
      'touch-action:manipulation;-webkit-tap-highlight-color:transparent;max-width: 16.6vw;' +
      '}' +
      '.primary-images .slider-nav.slider-nav--static>.product-thumb.is-active{opacity:1;}' +
      '.primary-images .slider-nav.slider-nav--static>.product-thumb.is-active img{' +
      'border:1px solid #68AEFF;' +
      '}' +
      '.primary-images .slider-nav.slider-nav--static>.product-thumb img{' +
      'display:block;width:100%;height:auto;aspect-ratio:1;object-fit:cover;pointer-events:none;' +
      '}' +
      '}';
    document.head.appendChild(style);
  }

  window.isIOSSafari = isIOSSafari;
  injectGalleryStyles();

  function syncMobileNav($nav, index) {
    $nav.find('.product-thumb').removeClass('is-active');
    $nav.find('.product-thumb').eq(index).addClass('is-active');
  }

  function bindMobileNav($section, $for, $nav) {
    $nav.off('.mobileThumb');
    $for.off('.mobileThumb');

    $nav.children('div').each(function (i) {
      jQuery(this).addClass('product-thumb').attr('data-thumb-index', i);
    });

    var goTo = function (index) {
      if (isNaN(index)) return;
      $for.slick('slickGoTo', index, false);
      syncMobileNav($nav, index);
    };

    $for.on('afterChange.mobileThumb', function (e, slick, currentSlide) {
      syncMobileNav($nav, currentSlide);
    });

    $nav.on('pointerup.mobileThumb', '.product-thumb', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      e.preventDefault();
      goTo(parseInt(jQuery(this).attr('data-thumb-index'), 10));
    });

    syncMobileNav($nav, $for.slick('slickCurrentSlide') || 0);
  }

  function cleanupMobileNav($nav) {
    $nav.off('.mobileThumb');
    $nav.removeClass('slider-nav--static');
    $nav.children('.product-thumb').removeClass('product-thumb is-active').removeAttr('data-thumb-index');
  }

  function initMobileGallery(sectionEl, sectionSelector) {
    var $section = jQuery(sectionEl);
    var $for = $section.find('.slider-for');
    var $nav = $section.find('.slider-nav');

    if ($nav.hasClass('slick-initialized')) {
      $nav.slick('unslick');
    }
    if ($for.hasClass('slick-initialized')) {
      $for.slick('unslick');
    }

    cleanupMobileNav($nav);
    $nav.addClass('slider-nav--static');

    $for.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: false,
      dots: true,
      infinite: true,
      swipe: true,
      touchMove: true,
      waitForAnimate: false
    });

    bindMobileNav($section, $for, $nav);
    $section.data('gallery-mode', 'mobile');
  }

  function initDesktopGallery(sectionEl, sectionSelector, imageMobGallery) {
    var $section = jQuery(sectionEl);
    var $for = $section.find('.slider-for');
    var $nav = $section.find('.slider-nav');

    cleanupMobileNav($nav);

    if ($for.hasClass('slick-initialized')) $for.slick('unslick');
    if ($nav.hasClass('slick-initialized')) $nav.slick('unslick');

    $for.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      dots: true
    });

    $nav.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: sectionSelector + ' .slider-for',
      dots: true,
      centerMode: true,
      focusOnSelect: true,
      vertical: true
    });

    var slickSlides = $nav.find('.slick-slide[aria-hidden="true"]');
    for (var i = 0; i < slickSlides.length; i++) {
      jQuery(slickSlides[i]).attr('aria-hidden', false);
    }

    $section.data('gallery-mode', 'desktop');
  }

  window.destroyProductInfoSliders = function (sectionEl) {
    if (!sectionEl || !window.jQuery) return;

    var $section = jQuery(sectionEl);
    var $nav = $section.find('.slider-nav');
    var $for = $section.find('.slider-for');

    $for.off('.mobileThumb');
    cleanupMobileNav($nav);

    $section.find('.slider-for, .slider-nav').each(function () {
      var $slider = jQuery(this);
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick');
      }
    });

    $section.data('sliders-initialized', false);
    $section.data('gallery-mode', null);
  };

  function forceLoadImages($section) {
    $section.find('.primary-images img').each(function () {
      var img = this;
      img.removeAttribute('loading');
      img.loading = 'eager';

      var src = img.getAttribute('src') ||
        img.getAttribute('data-src') ||
        img.getAttribute('data-lazy');

      if (!src) return;

      if (!img.complete || img.naturalWidth === 0) {
        img.src = src;
      }
    });
  }

  window.initProductInfoGallery = function (sectionEl, options) {
    if (!sectionEl || !window.jQuery) return;

    options = options || {};
    var $section = jQuery(sectionEl);
    var sectionSelector = '#' + sectionEl.id;

    if ($section.data('sliders-initialized')) {
      if (window.isIOSSafari && window.isIOSSafari()) {
        window.destroyProductInfoSliders(sectionEl);
      } else {
        window.refreshProductInfoSliders(sectionEl);
        return;
      }
    }

    window.destroyProductInfoSliders(sectionEl);

    if (isMobileGallery() && options.imageMobGallery) {
      initMobileGallery(sectionEl, sectionSelector);
    } else {
      initDesktopGallery(sectionEl, sectionSelector, !!options.imageMobGallery);
    }

    $section.data('sliders-initialized', true);
    forceLoadImages($section);
  };

  window.refreshProductInfoSliders = function (sectionEl) {
    if (!sectionEl || !window.jQuery) return;

    var $section = jQuery(sectionEl);
    forceLoadImages($section);

    var refresh = function () {
      var mode = $section.data('gallery-mode');

      if (mode === 'mobile') {
        var $for = $section.find('.slider-for');
        var $nav = $section.find('.slider-nav');
        if ($for.hasClass('slick-initialized')) {
          var current = $for.slick('slickCurrentSlide');
          $for.slick('setPosition');
          syncMobileNav($nav, current);
        }
        return;
      }

      $section.find('.slider-for, .slider-nav').each(function () {
        var $slider = jQuery(this);
        if (!$slider.hasClass('slick-initialized')) return;
        var current = $slider.slick('slickCurrentSlide');
        $slider.slick('setPosition');
        $slider.slick('refresh');
        $slider.slick('slickGoTo', current, true);
      });

      window.dispatchEvent(new Event('resize'));
    };

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        refresh();
        if (isIOSSafari()) {
          setTimeout(refresh, 150);
          setTimeout(refresh, 350);
        }
      });
    });
  };

  function showFlavorSection(currentSection, newSection) {
    newSection.classList.remove('hidden', 'visible-hide');
    currentSection.classList.add('hidden');

    void newSection.offsetHeight;

    var sectionId = newSection.id.replace('shopify-section-', '');
    var initFn = window.initProductInfoSliders[sectionId];

    var run = function () {
      if (isIOSSafari()) {
        window.destroyProductInfoSliders(newSection);
        void newSection.offsetHeight;
      }

      if (initFn) {
        initFn();
      } else {
        window.refreshProductInfoSliders(newSection);
      }
    };

    if (isIOSSafari()) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          setTimeout(run, 120);
        });
      });
    } else {
      run();
    }
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a.link-flavor-select');
    if (!link) return;

    e.preventDefault();

    var currentSection = link.closest('.section-product-info');
    var newSection = document.querySelector('.section-product-info.hidden');
    if (!currentSection || !newSection) return;

    showFlavorSection(currentSection, newSection);
  });
})();
